// ============================================================
// Prepared answer for the `assistant` AI task (#76): routes a request
// by keywords to one of the supported actions. Plain JS: the Worker
// imports it. Demo text is Czech or English.
// ============================================================

const VIEW_WORDS = [
  [/dopravc|carrier|przewo|spedit|scorecard/i, '/statistiky/dopravci'],
  [/urgenc|follow-up|monit|nachfrag/i, '/statistiky/urgence'],
  [/areál|areal|brán|gate|heatmap|site/i, '/statistiky/areal'],
  [/report|souhrn|summary|raport|bericht/i, '/statistiky/reporty'],
  [/statist|kpi/i, '/statistiky'],
  [/mapa|map/i, '/kamiony/mapa'],
  [/import|nahrát|upload/i, '/kamiony/import'],
  [/plánov|planning|energ|ote/i, '/planovani'],
  [/objedn|order|zamów|auftr/i, '/objednavky'],
];

export function assistantDemo({ query, lang, loadings, routes }) {
  const cs = lang === 'cs';
  const q = query.toLowerCase();
  const label = (path) => routes.find(r => r.path === path)?.label || path;

  const loading = loadings.find(l => q.includes(l.id.toLowerCase()) || q.replace(/\s/g, '').includes(l.plate.toLowerCase().replace(/\s/g, '')));
  if (loading) {
    return {
      answer: cs ? `${loading.plate} (${loading.carrier}) je teď ve stavu „${loading.state}“, plán ${loading.plannedAt}.` : `${loading.plate} (${loading.carrier}) is now "${loading.state}", planned ${loading.plannedAt}.`,
      action: { type: 'open-loading', loadingId: loading.id, path: null, label: cs ? `Otevřít ${loading.plate}` : `Open ${loading.plate}` },
    };
  }
  if (/urgov|(spus|spusť|pošl|send|run|start|uruchom|wyślij).*(urgen|kontrol|check|follow|monit)|urgen.*(spus|pošl)|13:00/i.test(q)) {
    const n = loadings.filter(l => l.state === 'no-info').length;
    return {
      answer: cs ? `Bez informace je ${n} nakládek. Kontrola 13:00 jim pošle urgenci.` : `${n} loadings have no information. The 13:00 check sends them a follow-up.`,
      action: { type: 'follow-up', loadingId: null, path: null, label: cs ? 'Spustit kontrolu 13:00' : 'Run the 13:00 check' },
    };
  }
  const view = VIEW_WORDS.find(([re]) => re.test(q))?.[1];
  if (view) {
    return {
      answer: cs ? `Otevřu ${label(view)}.` : `I will open ${label(view)}.`,
      action: { type: 'navigate', loadingId: null, path: view, label: cs ? `Přejít: ${label(view)}` : `Go to: ${label(view)}` },
    };
  }
  return {
    answer: cs
      ? 'Umím otevřít nakládku (napište SPZ nebo K-01), spustit kontrolu 13:00 a přejít na pohled (dopravci, urgence, areál, reporty…).'
      : 'I can open a loading (type a plate or K-01), run the 13:00 check and open a view (carriers, follow-ups, site, reports…).',
    action: null,
  };
}
